import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { DeleteButton } from '../components/DeleteButton'; // Import DeleteButton from your components
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ActionCell = ({ row, onEdit, onDelete }) => (
    <div style={{ display: 'flex', gap: '15px' }}>
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Update</Tooltip>}
        >
            <button 
                className="btn action-icon" 
                onClick={() => onEdit(row.id)}
                style={{ padding: '0', border: 'none', background: 'none' }}
            >
                <FontAwesomeIcon 
                    icon={faPen} 
                    style={{ color: '#007bff', fontSize: '16px' }}
                />
            </button>
        </OverlayTrigger>

        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-delete-${row.id}`}>Delete</Tooltip>}
        >
            <button 
                className="btn action-icon" 
                onClick={() => onDelete(row.id)}
                style={{ padding: '0', border: 'none', background: 'none' }}
            >
                <DeleteButton />
            </button>
        </OverlayTrigger>
    </div>
);

ActionCell.propTypes = {
    row: PropTypes.shape({
        id: PropTypes.number.isRequired,
    }).isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default ActionCell;